import React, { useEffect, useRef, useState } from "react";

export const UploadingInput = ({ onFileSelect, uploadError, uploadedFile, format, disable, clear }) => {

  const fileInputRef = useRef();
  const [isDragging, setIsDragging] = useState(false);

  const [previewUrl, setPreviewUrl] = useState(null);
  useEffect(() => {
    if (uploadedFile == null) {
      setPreviewUrl(null)
    }
  }, [uploadedFile]);

  useEffect(()=>{
    fileInputRef.current.value = "";
  },[clear])

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    onFileSelect(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        let updatedPreviewUrls = previewUrl;
        updatedPreviewUrls = reader.result;
        setPreviewUrl(updatedPreviewUrls);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChooseFile = (e) => {
    fileInputRef.current.click();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    onFileSelect(file);
  };
  return (
    <div
      className={`border-2 border-dashed border-input rounded-lg p-8 ${isDragging ? "bg-gray-100" : ""
        } ${disable ? "cursor-not-allowed": 'cursor-default'}`}
      onDragOver={!disable ? handleDragOver : null}
      onDragLeave={!disable ? handleDragLeave : null}
      onDrop={!disable ?  handleDrop : null}
    >
      <input
        type="file"
        accept={format ? format : ".jpg, .jpeg, .png, .pdf"}
        onChange={handleFileChange}
        ref={fileInputRef}
        className="hidden"
        disabled={disable}
      />
      {uploadedFile && previewUrl ? (
        <div className="w-full h-36 overflow-hidden border-input rounded-lg border-2 bg-uploadImg">
          <img
            src={previewUrl}
            alt="Preview"
            height="50px"
            className="mx-auto w-3/5"
          />
        </div>
      ) : (
        <div className="text-center">
          <div>
            <svg
              className={`w-12 h-12 mx-auto mb-4 text-gray-500 ${!disable ? "cursor-pointer" : "cursor-not-allowed"}`}
              width="49"
              height="38"
              viewBox="0 0 49 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={!disable ? handleChooseFile : null}
            >
              <path
                d="M40.4927 12.6436C38.2742 3.80599 29.3117 -1.55986 20.4741 0.65858C13.5677 2.3923 8.55291 8.36136 8.03622 15.4632C3.13241 16.2719 -0.187381 20.9027 0.621312 25.8065C1.3402 30.1661 5.11773 33.3588 9.53605 33.3412H17.0352V30.3416H9.53605C6.22273 30.3416 3.53671 27.6555 3.53671 24.3422C3.53671 21.0289 6.22273 18.3429 9.53605 18.3429C10.3644 18.3429 11.0359 17.6714 11.0359 16.843C11.0284 9.388 17.0659 3.33841 24.5209 3.33101C30.9743 3.32454 36.5296 7.88685 37.778 14.2183C37.8381 14.5266 37.9934 14.8083 38.2222 15.0236C38.4509 15.2388 38.7414 15.3769 39.0528 15.4182C43.1532 16.0021 46.0037 19.7994 45.4199 23.8997C44.8956 27.5816 41.752 30.323 38.0329 30.3416H32.0336V33.3412H38.0329C43.8313 33.3237 48.5175 28.609 48.4999 22.8106C48.4853 17.9839 45.1815 13.789 40.4927 12.6436Z"
                fill="#5B8098"
              />
              <path
                d="M23.4696 18.778L17.4702 24.7773L19.585 26.8921L23.0346 23.4575V37.8409H26.0343V23.4575L29.4689 26.8921L31.5837 24.7773L25.5843 18.778C24.9993 18.1964 24.0546 18.1964 23.4696 18.778Z"
                fill="#5B8098"
              />
            </svg>
            <p className="text-sm text-secondarytwo">
              {isDragging ? "Drop the file here" : "Drag & drop or "}
              <button
                type="button"
                onClick={!disable ? handleChooseFile : null}
                className={`text-primaryText font-semibold focus:outline-none ${!disable ? "cursor-pointer" : "cursor-not-allowed"}`}
              >
                Select file
              </button>{" "}
              to upload
              <span className="text-f12 text-secondary block">
                Supported format : {format ? (format.slice(1)).toUpperCase() : "JPG, JPEG, PNG, PDF"}
              </span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
